var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDna(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.002 512.002",
    style: {
      enableBackground: "new 0 0 512.002 512.002"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BDFBFD"
    },
    cx: 256.001,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00E4ED"
    },
    d: "M512.001,256c0-0.521-0.017-1.04-0.019-1.56L331.853,74.311l-10.912,21.94h-92.993l-21.94-21.94 l-7.47,67.458L256.001,256l-75.852,181.689l74.292,74.292c0.521,0.003,1.038,0.021,1.56,0.021 C397.385,512,512.001,397.384,512.001,256z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.939,
    y: 93.367,
    style: {
      fill: "#FF6178"
    },
    width: 110.114,
    height: 13.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.432,
    y: 93.367,
    style: {
      fill: "#FF0647"
    },
    width: 55.63,
    height: 13.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.87,
    y: 127.983,
    style: {
      fill: "#FF6178"
    },
    width: 102.245,
    height: 13.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.432,
    y: 127.983,
    style: {
      fill: "#FF0647"
    },
    width: 51.698,
    height: 13.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.87,
    y: 162.582,
    style: {
      fill: "#FF6178"
    },
    width: 102.245,
    height: 13.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.432,
    y: 162.582,
    style: {
      fill: "#FF0647"
    },
    width: 51.698,
    height: 13.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.247,
    y: 197.198,
    style: {
      fill: "#FF6178"
    },
    width: 75.509,
    height: 13.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.432,
    y: 197.198,
    style: {
      fill: "#FF0647"
    },
    width: 38.322,
    height: 13.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.939,
    y: 404.842,
    style: {
      fill: "#FF6178"
    },
    width: 110.114,
    height: 13.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.432,
    y: 404.842,
    style: {
      fill: "#FF0647"
    },
    width: 55.63,
    height: 13.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.87,
    y: 370.226,
    style: {
      fill: "#FF6178"
    },
    width: 102.245,
    height: 13.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.432,
    y: 370.226,
    style: {
      fill: "#FF0647"
    },
    width: 51.698,
    height: 13.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.87,
    y: 335.627,
    style: {
      fill: "#FF6178"
    },
    width: 102.245,
    height: 13.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.432,
    y: 335.627,
    style: {
      fill: "#FF0647"
    },
    width: 51.698,
    height: 13.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.247,
    y: 301.011,
    style: {
      fill: "#FF6178"
    },
    width: 75.509,
    height: 13.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.432,
    y: 301.011,
    style: {
      fill: "#FF0647"
    },
    width: 38.322,
    height: 13.791
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005E8B"
    },
    d: "M206.008,437.689h-25.859c0-94.885,33.158-142.757,65.224-189.05 c31.175-45.009,60.621-87.523,60.621-174.328h25.859c0,94.886-33.158,142.757-65.224,189.05 C235.454,308.371,206.008,350.885,206.008,437.689z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00447D"
    },
    d: "M331.853,74.311h-25.859c0,77.379-23.402,119.561-50.567,159.694v45.687 c3.677-5.461,7.425-10.878,11.202-16.331C298.695,217.067,331.853,169.196,331.853,74.311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00447D"
    },
    d: "M331.853,437.689h-25.859c0-86.804-29.446-129.317-60.621-174.327 c-32.066-46.295-65.224-94.167-65.224-189.052h25.859c0,86.804,29.446,129.317,60.621,174.327 C298.695,294.933,331.853,342.804,331.853,437.689z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#062964"
    },
    d: "M331.853,437.689c0-94.885-33.158-142.757-65.224-189.05c-3.777-5.453-7.525-10.869-11.202-16.331 v45.687c27.165,40.131,50.567,82.313,50.567,159.694L331.853,437.689L331.853,437.689z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDna);
export default __webpack_public_path__ + "static/media/dna.a6b20d5370dd488b458be983afbca964.svg";
export { ForwardRef as ReactComponent };